import styled, { css } from 'styled-components';

import { ReactComponent as FilterIcon } from '../../../../assets/images/blueTheme/filter.svg';

export const StyledFilterWrapper = styled.div`
  position: relative;
`;

export const StyledFilterIcon = styled(FilterIcon)<{ $active?: boolean }>(
  ({ theme: { admanColors }, $active }) => css`
    min-width: 11px;
    height: 11px;
    margin: ${({ theme: { spacers } }): string => `0 ${spacers!.spacer01}`};

    &:hover {
      cursor: pointer;
    }

    path {
      fill: ${$active ? admanColors!.blue.dark.bg1[0] : admanColors!.gray.light.bg3[1]};
    }
  `
);

export const StyledFooter = styled.div(
  ({ theme: { admanColors, spacers } }) => css`
    padding: ${spacers?.spacer02} ${spacers?.spacer04};
    border-top: 1px solid ${admanColors!.gray.light.bg3[2]};
    gap: 4px;
    display: flex;
    align-items: baseline;
    justify-content: flex-end;
    margin-top: ${spacers?.spacer03};
  `
);

export const StyledContentWrapper = styled.div(
  ({ theme: { spacers } }) => css`
    padding: ${spacers!.spacer04};
    display: grid;
    grid-template-columns: 1fr 1fr;
  `
);

export const StyledMinInput = styled.input<{ $error?: boolean }>(
  ({ theme: { admanColors, spacers }, $error }) => css`
    border: 1px solid ${$error ? admanColors!.red.dark.fg[2] : admanColors!.gray.light.bg3[2]};
    height: 35px;
    padding: ${spacers!.spacer02} ${spacers!.spacer04};
    margin-top: ${spacers!.spacer01};
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  `
);

export const StyledMaxInput = styled.input<{ $error?: boolean }>(
  ({ theme: { admanColors, spacers }, $error }) => css`
    border: 1px solid ${$error ? admanColors!.red.dark.fg[2] : admanColors!.gray.light.bg3[2]};
    padding: ${spacers!.spacer02} ${spacers!.spacer04};
    margin-top: ${spacers!.spacer01};
    border-left: none;
    height: 35px;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  `
);

export const StyledError = styled.div(
  ({ theme: { admanColors, spacers } }) => css`
    padding-left: ${spacers!.spacer04};
    color: ${admanColors!.red.dark.fg[2]};
    font-size: 15px;
    letter-spacing: 0;
    text-transform: none;
  `
);

export const StyledText = styled.div<{ $error?: boolean }>(
  ({ theme: { admanColors }, $error }) => css`
    color: ${$error ? admanColors!.red.dark.fg[2] : admanColors!.gray.light.fg1[1]};
  `
);

export const StyledInputWrapper = styled.span<{ $showCurrency: boolean }>(
  ({ theme: { spacers, colors }, $showCurrency }) => css`
    position: relative;

    &::before {
      position: absolute;
      top: 14px;
      content: '$';
      left: 4px;
      z-index: 1;
      font-size: 14px;
      visibility: ${$showCurrency ? 'visible' : 'hidden'};
    }

    &::after {
      position: absolute;
      top: 10px;
      display: block;
      content: '$';
      border: none;
      right: 10px;
      z-index: 1;
      font-size: 14px;
      width: 24px;
      color: ${colors!.colorWhite};
      background: ${colors!.colorWhite};
      height: 26px;
    }
  `
);
